import { useEffect, useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { TITLE_SUFFIX, titleForPath } from "@/lib/document-title";
import { getPageTitle, subscribePageTitle } from "@/lib/document-title-store";

/**
 * Atualiza `document.title` com base na rota e no nome publicado via `useDocumentTitle`.
 * 
 * MUST: Monte apenas uma vez no router (ao lado de `RouteAnalytics`).
 * Evita instâncias aninhadas que causavam race conditions e títulos obsoletos em erros.
 */
export function DocumentTitle() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const pageTitle = useSyncExternalStore(subscribePageTitle, getPageTitle, getPageTitle);

  useEffect(() => {
    document.title = pageTitle
      ? `${pageTitle} · ${TITLE_SUFFIX}`
      : titleForPath(pathname, t);
    // `i18n.language` entra nas dependências para o título ser reescrito quando
    // a preferência da conta chega depois do login e troca o idioma.
  }, [pathname, pageTitle, t, i18n.language]);

  return null;
}
